import Decimal from 'decimal.js';

import {assertNever} from 'util/Types';

/** A set of potential rounding strategies for decimal numbers
 *
 * Keep in sync with benchling/lib/core/float_util.py#DecimalRoundingStrategy
 */
export enum DecimalRoundingStrategy {
  ROUND_CEILING = 'ROUND_CEILING', // Always round towards the positive direction
  ROUND_FLOOR = 'ROUND_FLOOR', // Always round towards negative direction
  ROUND_DOWN = 'ROUND_DOWN', // Always round towards 0
  ROUND_UP = 'ROUND_UP', // Always round away from 0
  ROUND_HALF_UP = 'ROUND_HALF_UP', // Round numbers ending in 5 away from 0 (what you know from math class)
  ROUND_HALF_DOWN = 'ROUND_HALF_DOWN', // Round numbers ending in 5 towards 0
  ROUND_HALF_EVEN = 'ROUND_HALF_EVEN', // Round numbers ending in 5 towards the next even number (banker's rounding)
}

/** Convert a DecimalRoundingStrategy to a Decimal.js rounding mode */
export function decimalRoundingStrategyToDecimalJSRoundingMode(
  decimalRoundingStrategy: DecimalRoundingStrategy
): Decimal.Rounding {
  switch (decimalRoundingStrategy) {
    case DecimalRoundingStrategy.ROUND_CEILING:
      return Decimal.ROUND_CEIL;
    case DecimalRoundingStrategy.ROUND_FLOOR:
      return Decimal.ROUND_FLOOR;
    case DecimalRoundingStrategy.ROUND_DOWN:
      return Decimal.ROUND_DOWN;
    case DecimalRoundingStrategy.ROUND_UP:
      return Decimal.ROUND_UP;
    case DecimalRoundingStrategy.ROUND_HALF_UP:
      return Decimal.ROUND_HALF_UP;
    case DecimalRoundingStrategy.ROUND_HALF_DOWN:
      return Decimal.ROUND_HALF_DOWN;
    case DecimalRoundingStrategy.ROUND_HALF_EVEN:
      return Decimal.ROUND_HALF_EVEN;
    default:
      assertNever(decimalRoundingStrategy);
      return Decimal.ROUND_HALF_UP;
  }
}
